import type { RequestExportBatch } from '@magimp/shared';

import { requestBlob, type BinaryDownloadResult } from '../client.js';

export function downloadRequestsBatchXlsx(
  input: RequestExportBatch,
  opts: { signal?: AbortSignal } = {},
): Promise<BinaryDownloadResult> {
  return requestBlob('/requests/export.xlsx', opts, { method: 'POST', jsonBody: input });
}
